import React, { useState } from "react";
import { Alert, Collapse, Stack } from "@mui/material";
import { Global_Data } from '../../globalData/GlobalData';

const TYPE_TO_SEVERITY = {
  SUCCESS: 'success',
  ERROR: 'error',
  WARNING: 'warning',
  INFO: 'info',
};

function AlertItem({ alert, onDismiss }) {
  const [open, setOpen] = useState(true);
  const severity = alert?.severity || TYPE_TO_SEVERITY[alert?.type] || "info";

  return (
    <Collapse in={open} onExited={() => onDismiss(alert.id)}>
      <Alert
        id={alert.id}
        data-alert-id={alert.id}
        data-alert-severity={severity}
        data-alert-source={alert.source || "application"}
        severity={severity}
        onClose={() => setOpen(false)}
        sx={{ width: "100%" }}
      >
        {alert.message || alert.msg}
      </Alert>
    </Collapse>
  );
}

function SSEInfoAlert({ enabled = true }) {
  const { infoAlert, setInfoAlert, dismissInfoAlert } = Global_Data() || {};

  if (!enabled || !infoAlert?.length) return null;

  const dismiss = (id) => {
    if (dismissInfoAlert) {
      dismissInfoAlert(id);
      return;
    }

    setInfoAlert?.(prev => prev.filter(a => a.id !== id));
  };

  return (
    <Stack
      id="persistent-alert-section"
      data-testid="persistent-alert-section"
      aria-label="Persistent notifications"
      spacing={1}
      sx={{
        width: "100%",
        maxHeight: "40vh",
        overflowY: "auto",
        my: 1
      }}
    >
      {infoAlert.map(alert => (
        <AlertItem key={alert.id} alert={alert} onDismiss={dismiss} />
      ))}
    </Stack>
  );
}

export default SSEInfoAlert;
